<script>import CustomShapeProgressBar from "./CustomShapeProgressBar.svelte";
export let style = "default";
export let rx = 0.1;
export let ry = 0.1;
export let height = style == "thin" ? 1 : 14;
export let store;
export let labelAlignY = style == "thin" ? "above" : "middle";
export let actWidth = 0;
const roundedRect = (w, h) => {
  return [
    "M 0 " + ry,
    "A " + rx + " " + ry + " 0 0 1 " + rx + " 0",
    "H " + (w - rx) + " ",
    "A " + rx + " " + ry + " 0 0 1 " + w + " " + rx,
    "V " + (h - ry),
    "A " + rx + " " + ry + " 0 0 1 " + (w - rx) + " " + h,
    "H " + rx,
    "A " + rx + " " + ry + " 0 0 1 0 " + (h - ry),
    "Z"
  ].join(" ");
};
</script>

<CustomShapeProgressBar
	{...$$props}
	pathFn={roundedRect}
	{height}
	{store}
	{labelAlignY}
	{style}
	{actWidth}>
</CustomShapeProgressBar>